/* PPL shared FAQ accordion — Phase K accessibility fix (2026-08-29).
   Previously each page (homepage, PDP, FAQ page) duplicated its own near-identical
   inline accordion script, none of which set aria-expanded/aria-controls —
   B6_PRODUCTION_HANDOFF.md's own pre-production review flagged this: "fully
   mouse/keyboard operable... but a screen reader won't announce expanded/collapsed
   state." Consolidated into one shared asset so the fix applies everywhere at once
   ("fixed once at the component level so every new page inherits the fix", per
   PPL_PRODUCTION_IMPLEMENTATION_PLAN_V1.md Phase K) instead of needing to be
   reapplied to 3 (and any future) duplicated copies.

   aria-controls/id pairing is generated at runtime rather than hand-authored in
   each page's markup — avoids any risk of duplicate ids across pages/groups. */
function pplInitFaqGroup(root){
  if(!root) return;
  var items = root.querySelectorAll('.faq-item');
  items.forEach(function(item, idx){
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    if(!q || !a) return;
    if(!a.id){ a.id = (root.id || 'faq') + '-panel-' + idx; }
    q.setAttribute('aria-controls', a.id);
    q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
    if(item.classList.contains('open')){ a.style.maxHeight = a.scrollHeight + 'px'; }
    q.addEventListener('click', function(){
      var isOpen = item.classList.contains('open');
      items.forEach(function(other){
        other.classList.remove('open');
        other.querySelector('.faq-a').style.maxHeight = 0;
        other.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if(!isOpen){
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });
}
